import {
  PropertyPortal,
  PropertyPortalPublicationDisplayStatusFilter,
} from 'src/api/generated';
import type { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { PropertyPublicationPortalFilter } from '../schemas/property-publications-search.schema';
import { getPropertyPublicationProviderLabelKey } from './property-publication-display.util';

export const PROPERTY_PUBLICATION_STATUS_FILTER_OPTIONS = Object.values(
  PropertyPortalPublicationDisplayStatusFilter
);

export const PROPERTY_PUBLICATION_PORTAL_FILTER_OPTIONS: PropertyPublicationPortalFilter[] =
  ['ALL', PropertyPortal.MELI];

export const getPublicationStatusFilterLabelKey = (
  value: PropertyPortalPublicationDisplayStatusFilter
):
  | 'catalog.properties.publications.filters.status.all'
  | 'catalog.properties.publications.status.draft'
  | 'catalog.properties.publications.status.published'
  | 'catalog.properties.publications.status.paymentRequired'
  | 'catalog.properties.publications.status.underReview'
  | 'catalog.properties.publications.status.closed'
  | 'catalog.properties.publications.status.paused'
  | 'catalog.properties.publications.status.unpublished'
  | 'catalog.properties.publications.status.error' => {
  switch (value) {
    case PropertyPortalPublicationDisplayStatusFilter.DRAFT:
      return 'catalog.properties.publications.status.draft';
    case PropertyPortalPublicationDisplayStatusFilter.PUBLISHED:
      return 'catalog.properties.publications.status.published';
    case PropertyPortalPublicationDisplayStatusFilter.PAYMENT_PENDING:
      return 'catalog.properties.publications.status.paymentRequired';
    case PropertyPortalPublicationDisplayStatusFilter.UNDER_REVIEW:
      return 'catalog.properties.publications.status.underReview';
    case PropertyPortalPublicationDisplayStatusFilter.CLOSED:
      return 'catalog.properties.publications.status.closed';
    case PropertyPortalPublicationDisplayStatusFilter.PAUSED:
      return 'catalog.properties.publications.status.paused';
    case PropertyPortalPublicationDisplayStatusFilter.UNPUBLISHED:
      return 'catalog.properties.publications.status.unpublished';
    case PropertyPortalPublicationDisplayStatusFilter.ERROR:
      return 'catalog.properties.publications.status.error';
    case PropertyPortalPublicationDisplayStatusFilter.ALL:
    default:
      return 'catalog.properties.publications.filters.status.all';
  }
};

export const getPublicationPortalFilterLabel = (
  portal: PropertyPublicationPortalFilter,
  t: ReturnType<typeof useI18n>['t']
): string => {
  if (portal === 'ALL') {
    return t('catalog.properties.publications.filters.portal.all');
  }

  const providerLabelKey = getPropertyPublicationProviderLabelKey(portal);
  return providerLabelKey ? t(providerLabelKey) : portal;
};
